import React from 'react';
import { Menu } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { groupPagesBySlug } from './PopupAccordionMenuLink.utils';
import { MAX_LINKS_TO_SHOW } from './components/AccordionLinks/AccordionLinks.constants';
import AccordionsPopup from './components/AccordionsPopup';
import { SiteNavigationLinkPropType } from '../../../../../../services/proptypes';
import BaseLink from '../Link';
import './PopupAccordionMenuLink.css';
var defaultProps = {
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: []
};
export default function PopupAccordionMenuLink(_ref) {
  var link = _ref.link,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices;
  var title = link.title,
    url = link.url,
    slug = link.slug,
    pageType = link.pageType,
    as = link.as,
    className = link.className,
    childPages = link.childPages;
  var groupedChildPages = groupPagesBySlug(childPages);
  if (_isEmpty(groupedChildPages)) {
    return /*#__PURE__*/React.createElement(BaseLink, {
      title: title,
      url: url,
      slug: slug,
      type: pageType.toLowerCase(),
      as: as,
      className: className
    });
  }
  return /*#__PURE__*/React.createElement(Menu.Item, {
    className: "popup-accordions-menu-link"
  }, /*#__PURE__*/React.createElement(AccordionsPopup, {
    parentLink: link,
    links: groupedChildPages,
    maxLinksToShow: maxLinksToShow,
    initialActiveIndices: initialActiveIndices
  }));
}
PopupAccordionMenuLink.defaultProps = defaultProps;